var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCreateAccountEmail = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "306px",
    height: "91px",
    viewBox: "0 0 306 91",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Image / Email -master") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-6.0%",
    y: "-29.4%",
    width: "112.1%",
    height: "182.4%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.774003623   0 0 0 0 0.765816542   0 0 0 0 0.737161759  0 0 0 1 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    x: "-6.4%",
    y: "-28.1%",
    width: "113.2%",
    height: "181.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.774003623   0 0 0 0 0.765816542   0 0 0 0 0.737161759  0 0 0 1 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Image-/-Email--master",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Email"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#E4E2DB",
    fill: "#FFFFFF",
    x: 0.5,
    y: 0.5,
    width: 305,
    height: 73,
    rx: 7
  }), /*#__PURE__*/React.createElement("text", {
    id: "Amica-Mutual-Insuran",
    fontFamily: "TimesNewRomanPS-BoldMT, Times New Roman",
    fontSize: 8,
    fontWeight: "bold",
    fill: "#000000",
    fillOpacity: 0.5
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 92.4414062,
    y: 11
  }, "Amica Mutual Insurance Company")), /*#__PURE__*/React.createElement("text", {
    id: "DECLARATIONS",
    fontFamily: "Avenir-Heavy, Avenir",
    fontSize: 7,
    fontWeight: 600,
    fill: "#000000",
    fillOpacity: 0.5
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 10,
    y: 31
  }, "DECLARATIONS")), /*#__PURE__*/React.createElement("text", {
    id: "Page-3-of-3",
    fontFamily: "Avenir-Heavy, Avenir",
    fontSize: 5,
    fontWeight: 600,
    fill: "#000000",
    fillOpacity: 0.5
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 269.07,
    y: 17
  }, "Page 3 of 3")), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillOpacity: 0.75,
    fill: "#E4E2DB",
    x: 10,
    y: 38,
    width: 97,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillOpacity: 0.75,
    fill: "#E4E2DB",
    x: 142,
    y: 38,
    width: 155,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillOpacity: 0.75,
    fill: "#E4E2DB",
    x: 181,
    y: 48,
    width: 116,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillOpacity: 0.75,
    fill: "#E4E2DB",
    x: 225,
    y: 58,
    width: 72,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillOpacity: 0.75,
    fill: "#E4E2DB",
    x: 142,
    y: 24,
    width: 37,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillOpacity: 0.75,
    fill: "#E4E2DB",
    x: 29,
    y: 48,
    width: 65,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillOpacity: 0.75,
    fill: "#E4E2DB",
    x: 29,
    y: 58,
    width: 55,
    height: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 29.5,
    y1: 33.5,
    x2: 258.5,
    y2: 33.5,
    id: "Line-2",
    stroke: "#E4E2DB",
    strokeWidth: 0.5,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 29.5,
    y1: 35.5,
    x2: 258.5,
    y2: 35.5,
    id: "Line-2",
    stroke: "#E4E2DB",
    strokeWidth: 0.5,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Policy-NO",
    filter: "url(#filter-1)",
    transform: "translate(182, 20)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#000000",
    fill: "#FFFFFF",
    x: 0.5,
    y: 0.5,
    width: 115,
    height: 16,
    rx: 2
  }), /*#__PURE__*/React.createElement("text", {
    id: "POLICY-NO.-0000000-X",
    fontFamily: "SFProText-Semibold, SF Pro Text",
    fontSize: 8,
    fontWeight: 500,
    "line-spacing": 17,
    letterSpacing: -0.4,
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 6,
    y: 8
  }, "POLICY NO. 0000000-XXXX"))), /*#__PURE__*/React.createElement("path", {
    id: "Line-3",
    d: "M182.892869,36.1907202 L178.604746,45.2935771 L176.13,42.15 L135.80928,73.8928689 L135.416411,74.2021487 L134.797851,73.4164109 L135.19072,73.1071311 L175.512,41.364 L173.03771,38.2219362 L182.892869,36.1907202 Z",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#E4E2DB",
    fill: "#FFFFFF",
    x: 0.5,
    y: 0.5,
    width: 305,
    height: 73,
    rx: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Header",
    opacity: 0.597246,
    transform: "translate(11, 21)",
    fill: "#000000",
    fontFamily: "Avenir-Heavy, Avenir",
    fontSize: 7,
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("text", {
    id: "Please-review-and-si"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 7
  }, "Please review and sign your documents"))), /*#__PURE__*/React.createElement("text", {
    id: "Dear-Customer,",
    fontFamily: "Avenir-Medium, Avenir",
    fontSize: 6,
    fontWeight: 400,
    fill: "#000000",
    fillOpacity: 0.5
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 11,
    y: 38
  }, "Dear Customer,")), /*#__PURE__*/React.createElement("text", {
    id: "\\u2022-If-you-are-creatin",
    fontFamily: "SFProDisplay-Regular, SF Pro Display",
    fontSize: 7,
    fontWeight: "normal",
    fill: "#000000",
    fillOpacity: 0.5
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 12,
    y: 58
  }, "\u2022 If you are creating an Amica online account, you will need your")), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillOpacity: 0.75,
    fill: "#E4E2DB",
    x: 11,
    y: 40,
    width: 288,
    height: 9
  }), /*#__PURE__*/React.createElement("g", {
    id: "Account-Number",
    filter: "url(#filter-2)",
    transform: "translate(197, 48)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#000000",
    fill: "#FFFFFF",
    x: 1,
    y: 1,
    width: 100.5,
    height: 14,
    rx: 2
  }), /*#__PURE__*/React.createElement("text", {
    id: "account-number:-N000",
    fontFamily: "SFProDisplay-Regular, SF Pro Display",
    fontSize: 7,
    fontWeight: "normal",
    "line-spacing": 8,
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 2,
    y: 10
  }, "account number"), /*#__PURE__*/React.createElement("tspan", {
    x: 49.7797852,
    y: 10,
    letterSpacing: -0.35
  }, ": "), /*#__PURE__*/React.createElement("tspan", {
    x: 51.187793,
    y: 10.0495605,
    fontFamily: "Avenir-Heavy, Avenir",
    fontSize: 8,
    fontWeight: 600,
    letterSpacing: -0.4
  }, "N000000000"))), /*#__PURE__*/React.createElement("g", {
    id: "Account-Number",
    transform: "translate(30, 64)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#000000",
    x: 0,
    y: 0,
    width: 138,
    height: 27,
    rx: 1
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "SFProText-Semibold, SF Pro Text",
    fontSize: 14,
    fontWeight: 500,
    "line-spacing": 17,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 11,
    y: 18
  }, "Account Number"))), /*#__PURE__*/React.createElement("path", {
    id: "Line-3",
    d: "M187.88894,63.1428847 L197.950276,63.2826255 L191.801682,71.2478494 L190.062,67.645 L168.717375,77.9502758 L168.267099,78.1676504 L167.83235,77.2670987 L168.282625,77.0497242 L189.627,66.745 L187.88894,63.1428847 Z",
    fill: "#000000",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Logo/Primary-Wordmark/Teal-Copy-3",
    transform: "translate(11, 7)",
    fill: "#666666",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.1257185,3.33333333 C24.7872391,3.33333333 25.3164557,2.82951298 25.3164557,2.15748031 C25.3164557,1.48544765 24.7872391,1 24.1257185,1 C23.4641978,1 22.9535865,1.50382036 22.9535865,2.15748031 C22.9535865,2.81114027 23.4637843,3.33333333 24.1257185,3.33333333 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5966028,9.71882256 C39.1376415,9.71882256 39.0037604,9.26690885 39.0037604,8.77709535 L39.0037604,4.0495094 C38.6912316,4.20811175 38.3837234,4.34323272 38.0879297,4.4602277 C37.5737425,4.1240731 36.8896935,4.01202157 36.3449646,4.01202157 C34.4702102,4.01202157 32.7678278,5.29278706 32.7678278,7.57171747 C32.7678278,7.73155569 32.7749403,7.88562654 32.7887468,8.03393004 C32.3628374,9.09841959 31.6331852,9.68133473 30.7018745,9.68133473 C29.3438176,9.68133473 28.5212854,8.60778219 28.5593578,6.89364093 C28.5786032,5.55643772 29.1906911,4.57681073 29.8985876,4.57681073 C30.2429132,4.57681073 30.472603,4.8215115 30.472603,5.2923751 C30.472603,5.72575088 30.3006494,6.1587147 30.0136417,6.42236537 C30.2240861,6.79889147 30.6642204,7.04400419 31.1612541,7.04400419 C31.773342,7.04400419 32.2323033,6.57314059 32.2515487,5.87611415 C32.2707941,4.78361171 31.3143807,4.01160962 29.917833,4.01160962 C27.9284429,4.01160962 26.5892131,5.42420043 26.5892131,7.49591791 C26.5892131,7.82465733 26.6352348,8.15875215 26.7281148,8.48254812 C26.4323212,9.19440491 26.0369534,9.68051082 25.6516268,9.68051082 C25.3646191,9.68051082 25.2307379,9.49224777 25.2307379,8.90809677 L25.2307379,3.99307168 C24.5420868,4.35105985 23.8915081,4.59576062 23.3179111,4.78402367 L23.3179111,8.31241106 C23.0099845,9.11613362 22.5932794,9.68133473 22.1891257,9.68133473 C21.902118,9.68133473 21.7682369,9.49307168 21.7682369,8.90892068 L21.7682369,6.06478915 C21.7682369,4.57681073 21.1369036,4.01160962 20.1997357,4.01160962 C19.0855935,4.01160962 18.2898375,4.97146281 17.9225011,5.97333533 C17.8953065,4.55374129 17.2346867,4.01160962 16.3167642,4.01160962 C15.1800296,4.01160962 14.3650281,5.01059846 14.0022939,6.03389259 L14.0022939,3.99265973 C12.9534189,4.51707737 11.7547643,4.97434649 10.4059117,5.26312636 L10.4059117,0 C7.1350281,0.282600554 5.62384471,1.71414126 4.8393849,5.16096173 C4.79922056,5.33604224 4.75821946,5.50617931 4.71721836,5.67178489 C1.67309589,5.96344843 0,7.52846229 0,9.21047113 C0,10.3029736 0.822532265,11 1.95131764,11 C3.74909035,11 4.80591461,9.50584226 5.56276144,6.29218785 L8.37844921,6.17066137 L8.37844921,10.6988615 L10.4059117,10.6988615 L10.4059117,5.93213991 C11.0200915,5.81226125 11.5756982,5.66931316 12.0894671,5.50164782 L12.0894671,10.6984496 L14.0022939,10.6984496 L14.0022939,8.0990188 C14.0022939,6.3663396 14.9206349,5.42461239 15.4754049,5.42461239 C15.8770483,5.42461239 16.0109294,5.82008838 16.0109294,6.78076549 L16.0109294,10.6984496 L17.9237562,10.6984496 L17.9237562,8.0990188 C17.9237562,6.40382743 18.7655339,5.42461239 19.3010585,5.42461239 C19.6834565,5.42461239 19.8939009,5.82008838 19.8939009,6.78076549 L19.8939009,9.36124635 C19.8939009,10.3408733 20.3528622,10.8302749 21.2519578,10.8302749 C22.1510533,10.8302749 22.8535109,10.2840237 23.3229317,9.42056775 C23.375229,10.3602352 23.8668238,10.8302749 24.7337042,10.8302749 C25.7917836,10.8302749 26.532732,10.1583776 26.9845809,9.12602052 C27.4866352,10.0879335 28.4727535,10.8302749 29.9751509,10.8302749 C31.2704509,10.8302749 32.3615823,10.074339 32.9506593,8.86896113 C33.3535578,10.173208 34.3651972,10.8302749 35.3885512,10.8302749 C36.2274002,10.8302749 36.8767238,10.433563 37.3122558,9.68545427 C37.5026181,10.3746536 37.9971416,10.8302749 38.7167527,10.8302749 C39.4363638,10.8302749 40.0367371,10.3219235 39.9982463,9.60594712 C39.8836105,9.68133473 39.730484,9.71882256 39.5966028,9.71882256 Z M2.30304825,10 C1.84432035,10 1.51898734,9.67597998 1.51898734,9.16096747 C1.51898734,7.94578816 2.81279239,6.79274395 4.55696203,6.5 C3.9297133,8.75729775 3.18621447,10 2.30304825,10 Z M5.56962025,5.5 C6.21395963,2.62909179 7.10673337,1.86755707 8.10126582,1.5 L8.10126582,5.39781447 L5.56962025,5.5 Z M35.9954354,9.5 C35.0871706,9.5 34.4303797,8.46699217 34.4303797,6.91707691 C34.4303797,5.36716165 35.0292682,4.5 35.9764164,4.5 C36.2781852,4.5 36.6509583,4.57666855 36.9620253,4.88536034 L36.9620253,8.83540473 C36.9620253,8.8454927 36.9620253,8.85598418 36.9620253,8.86607215 C36.7468988,9.28936325 36.4303375,9.49959648 35.9954354,9.49959648 L35.9954354,9.5 Z",
    id: "Shape"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCreateAccountEmail);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/create-account-email.7a8896fe108f0b08f6554b7e7f449a15.svg";